import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from "./Media";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: [
      "Full Stack Developer.",
      "React/Vue/Angular Developer",
      "Python/Symfony Developer",
      "Flutter Developer",
      "DevOps.",
      "A big PSG fan 📸",
    ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className="text-lg font-normal">Hi 👀 🙋‍♂️</h4>
        <h1 className="text-6xl font-bold text-white">
          I'm <span className="text-designColor capitalize">Igor FOKO</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          Full Stack Developer with more than 4 years of experience, My passion for solution development has led me to explore various aspects of this field, and today I am learning new things in the field of mapping.
          <br />
          <br />
          However, my desire to explore new horizons is still burning, and if you need me to work on a stimulating project, don't hesitate to contact me.
          <br />
          <br />
          My satisfaction would be to work on a global project with millions of users.
        </p>
      </div>
      {/* Media */}
      <Media />
    </div>
  );
};

export default LeftBanner;
